define('views/base/modal',['require','underscore','jquery','views/base/view','text!templates/modal.ejs','views/base/modal-header','views/base/modal-footer'],function(require) {
    'use strict';

    var _ = require('underscore'),
        $ = require('jquery'),
        View = require('views/base/view'),
        template = require('text!templates/modal.ejs'),
        ModalHeaderView = require('views/base/modal-header'),
        ModalFooterView = require('views/base/modal-footer');

    var modals = [];

    function addModal(modal) {
        var lastModal = _.last(modals);
        if (lastModal) {
            lastModal.hide();
        }
        modals.push(modal);
    }

    function removeModal(modal) {
        modals = _.without(modals, modal);
        var lastModal = _.last(modals);
        if (lastModal) {
            lastModal.show();
        }
    }

    var ModalView = View.extend({
        autoRender: true,
        className: '',
        template: template,
        container: 'body',

        headerViewClass: ModalHeaderView,
        footerViewClass: ModalFooterView,

        regions: {
            'modal-content': '.modal-body'
        },

        animateClass: '',

        arguments: {
            'tabindex': '-1',
            'role': 'dialog',
            'aria-labelledby': 'modalDialogLabel',
            'aria-hidden': 'true'
        },

        initialize: function () {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', 'button.close', this.clickButton);
            this.delegate('click', '.modal-footer a', this.clickButton);

            this.listenTo(this.model, 'showPreloader', this.showPreloader);
            this.listenTo(this.model, 'hidePreloader', this.hidePreloader);

            this.model.set('animateClass', this.animateClass);

            if(this.model.get('showFooter') === undefined){
                this.model.set('showFooter', true);
            }

            addModal(this);

            return this;
        },

        render: function() {
            View.prototype.render.apply(this, arguments);

            this.$modalBody = this.$('.modal-body');

            var _this = this;

            var HeaderView = this.headerViewClass;
            var FooterView = this.footerViewClass;

            this.subview('header', new HeaderView({ model: this.model, el: this.$('.modal-header') }));
            this.subview('footer', new FooterView({ model: this.model, el: this.$('.modal-footer') }));


            if (this.animateClass) {
                setTimeout(function() {
                    _this.$('.modal').removeClass(_this.animateClass);
                }, 50);
            }
        },

        hide: function() {
            this.$el.hide();
        },

        show: function() {
            if(!this.model.get('leaveHide')){
                this.$el.show();
            }
        },

        clickButton: function(ev) {
            var $el = $(ev.target);
            var action = $el.data('action');
            var canceled = false;
            var cancel = function () { canceled = true; };
            this.action(action, cancel);
            if (!canceled) {
                if (this.model) {
                    this.model.dispose();
                }
            }
        },

        action: function(action, cancel) {
            this.model.trigger('action', action, cancel);
        },

        disableButtons: function() {
            $('.modal-footer a', this.$el).prop('disabled', true); // wtf???
            $('.modal-footer a', this.$el).addClass('disabled');
            $('button.close', this.$el).prop('disabled', true);
            $('button.close', this.$el).addClass('disabled');
        },
        enableButtons: function() {
            $('.modal-footer a', this.$el).prop('disabled', '');
            $('.modal-footer a', this.$el).removeClass('disabled');
            $('button.close', this.$el).prop('disabled', '');
            $('button.close', this.$el).removeClass('disabled');
        },
        dispose: function() {
            if (this.disposed) { return; }

            removeModal(this);

            View.prototype.dispose.apply(this, arguments);
        },
        showPreloader: function() {
            this.$('.modal-body').addClass('preloader');
        },
        hidePreloader: function() {
            this.$('.modal-body').removeClass('preloader');
        }
    });

    return ModalView;
});

